import { render, staticRenderFns } from "./MapSX.vue?vue&type=template&id=5a5d47ae&"
import script from "./MapSX.vue?vue&type=script&lang=js&"
export * from "./MapSX.vue?vue&type=script&lang=js&"
import style0 from "./MapSX.vue?vue&type=style&index=0&id=5a5d47ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports